<div class="tech-communities-title">
    <h3 class="title">{{this.data.title}}</h3>
</div>

<mat-card-content class="tech-communities-card-content">
    <div class="tech-communities-column">
        <h3 topazTitle="4">Request access</h3>
        <div class="tech-communities-access-info">
            <p>Submit a request to be granted access to {{this.data.accessto}}.</p>
        </div>
        <button type="button" class="tech-communities-action" aria-label="Request access" (click)="request()">
            <fa-icon [icon]="icons.faChevronRight" aria-hidden="true"></fa-icon>
        </button>
    </div>

    <div class="tech-communities-column">
        <h3 topazTitle="4">Sign in if you have MCT Lounge access.</h3>
        <div class="tech-communities-access-info">
            <p>For trainers who have submitted an access request and received an approval email.</p>
        </div>
        <button type="button" class="tech-communities-action" aria-label="Sign in" (click)="signin()">
            <fa-icon [icon]="icons.faChevronRight" aria-hidden="true"></fa-icon>
        </button>
    </div>
</mat-card-content>